/*
 * @Description: 总裁管理桌面
 * @Author: Scarlett Xiao
 * @Date: 2022-01-13 11:27:46
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-02-23 15:59:10
 */

import http from '../../axios/index';
/**
 * @brief: 年度经营目标完成情况图表（养成、育苗）
 * @author: Scarlett Xiao
 * @Date: 2022-01-13 11:35:44
 * @param {*} params 查询参数
 * orgId 以及机构id
 * year 年份（yyyy）
 * month 年月（yyyy-MM）
 * searchType 查询指标类型（1：完成情况、2：产量、3：产值、4：利润）
 * breedTypeClass 查询类型 （egg：育苗、fish：养成）
 */
export function annalsTargetInfo(params) {
  let {
    orgId,
    type,
    year,
    month,
    breedTypeClass,
    searchType
  } = params;
  return http.post('/targetAnalysisOrg/getTargetAnalysisOrgByChart', {
    orgId,
    type,
    year: type == 'M' ? '' : year,
    month: type == 'Y' ? '' : month,
    breedTypeClass,
    searchType
  });
}
/**
 * @brief: 投放概览
 * @author: Scarlett Xiao
 * @Date: 2022-01-13 11:50:24
 * @param {*} params 查询参数
 * orgId 一级机构id
 * type 时间类型（Y：年份 、M:月份）
 * year 年份（yyyy）
 * month 年月（yyyy-MM）
 * searchType 查询指标类型（1：投卵、2：排塘）
 * breedTypeClass 查询类型 （egg：育苗、fish：养成）
 */
export function putInfo(params) {
  let {
    orgId,
    type,
    year,
    month,
    breedTypeClass,
    searchType
  } = params;
  return searchType == '1'
    // 投卵、苗情况图表数据（养成、育苗）
    ?
    http.post('/outSeedlingDailyOrg/getOutSeedlingDailyOrgByChart', {
      orgId,
      type,
      year: type == 'M' ? '' : year,
      month: type == 'Y' ? '' : month,
      breedTypeClass
    })
    // 排塘情况图表数据（养成、育苗）
    :
    http.post('/mdtLossOrg/getMdtLossOrgByChart', {
      orgId,
      type,
      year: type == 'M' ? '' : year,
      month: type == 'Y' ? '' : month,
      breedTypeClass
    })
}
/**
 * @brief: 存塘概览
 * @author: Scarlett Xiao
 * @Date: 2022-01-13 13:49:40
 @param {*} params 查询参数
 * orgId 一级机构id
 * type 时间类型（Y：年份 、M:月份）
 * year 年份（yyyy）
 * month 年月（yyyy-MM）
 * searchType 查询指标类型（1：实时存塘量、2：月存塘成本）
 * breedTypeClass 查询类型 （egg：育苗、fish：养成）
 */
export function storageInfo(params) {
  let {
    orgId,
    rootId = orgId,
    type,
    year,
    month,
    breedTypeClass,
    searchType
  } = params;
  return searchType == '2'
    // 存塘概览-月存塘成本图表-（养成、育苗）
    ?
    http.post('/midCostTotalOrg/getMidCostTotalOrgChart', {
      rootId,
      type,
      year: type == 'M' ? '' : year,
      month: type == 'Y' ? '' : month,
      breedTypeClass,
    })
    // 实时存塘量（养成、育苗）图表 
    :
    http.post('/mdtPondStockOrg/getMdtPondStockOrgByChart', {
      orgId,
      type,
      year: type == 'M' ? '' : year,
      month: type == 'Y' ? '' : month,
      breedTypeClass,
    })
}
/**
 * @brief: 销售概览
 * @author: Scarlett Xiao
 * @Date: 2022-01-13 14:15:54
 * @param {*} params 查询参数
 * orgId 一级机构id
 * rootId 顶级机构id = 一级机构id
 * type 时间类型（Y：年份 、M:月份）
 * year 年份（yyyy）
 * month 年月（yyyy-MM）
 * searchType 查询指标类型（0：产值、1：销售量、2；客户应收）
 * breedTypeClass 查询类型 （egg：育苗、fish：养成）
 */
export function salesInfo(params) {
  let {
    orgId,
    rootId = orgId,
    type,
    year,
    month,
    breedTypeClass,
    searchType
  } = params;
  return searchType == '0' || searchType == '1'
    // 销售概览-产值、销售量（养成、育苗）图表
    ?
    http.post('/outSaleDailyOrg/getOutSaleDailyOrgByChart', {
      orgId,
      type,
      year: type == 'M' ? '' : year,
      month: type == 'Y' ? '' : month,
      searchType,
      breedTypeClass,
    })
    // 销售概览-客户应收养成育苗图表
    :
    http.post('/outMoneyReceive/getOutMoneyReceiveChart', {
      rootId,
      type,
      year: type == 'M' ? '' : year,
      month: type == 'Y' ? '' : month,
      breedTypeClass,
    })
}
/**
 * @brief: 单位利润计划与实际比
 * @author: Scarlett Xiao
 * @Date: 2022-01-13 14:24:52
 * @param {*} params 查询参数
 * orgId 一级机构id
 * type 时间类型（Y：年份 、M:月份）
 * year 年份（yyyy）
 * month 年月（yyyy-MM）
 * searchType 查询指标类型（0：成本、1：售价、2：利润）
 * breedTypeClass 查询类型 （egg：育苗、fish：养成）
 */
export function prefixInfo(params) {
  let {
    orgId,
    type,
    year,
    month,
    breedTypeClass,
    searchType
  } = params;
  return http.post('/outFishProfitOrg/getOutFishProfitOrgByChart', {
    orgId,
    type,
    year: type == 'M' ? '' : year,
    month: type == 'Y' ? '' : month,
    breedTypeClass,
    searchType
  })
}
/**
 * @brief: 成本概览
 * @author: Scarlett Xiao
 * @Date: 2022-01-13 14:27:58
 * @param {*} params 查询参数
 * orgId 一级机构id
 * type 时间类型（Y：年份 、M:月份）
 * year 年份（yyyy）
 * month 年月（yyyy-MM）
 * breedTypeClass 查询类型 （egg：育苗、fish：养成）
 */
export function costInfo(params) {
  let {
    orgId,
    type,
    year,
    month,
    breedTypeClass,
  } = params;
  return http.post('/outSaleCostOrg/getOutSaleCostOrgByChart', {
    orgId,
    type,
    year: type == 'M' ? '' : year,
    month: type == 'Y' ? '' : month,
    breedTypeClass,
  })
}
/**
 * @brief: 收获概览
 * @author: Scarlett Xiao
 * @Date: 2022-01-13 14:30:23
 * @param {*} params 查询参数
 * orgId 一级机构id
 * type 时间类型（Y：年份 、M:月份）
 * year 年份（yyyy）
 * month 年月（yyyy-MM）
 * searchType 查询指标类型（0：产量、1：收获情况）
 * breedTypeClass 查询类型 （egg：育苗、fish：养成）
 */
export function harvestInfo(params) {
  let {
    orgId,
    type,
    year,
    month,
    breedTypeClass,
    searchType
  } = params;
  return searchType == '0'
    // 收获概览-产量（养成、育苗）图表
    ?
    http.post('/outHarvestDailyOrg/getOutHarvestDailyOrgByChart', {
      orgId,
      type,
      year: type == 'M' ? '' : year,
      month: type == 'Y' ? '' : month,
      breedTypeClass,
    })
    // 收获概览-塘口收获情况（养成、育苗）图表
    :
    http.post('/mdtPondHarvest/getMdtPondHarvestByChart', {
      orgId,
      type,
      year: type == 'M' ? '' : year,
      month: type == 'Y' ? '' : month,
      breedTypeClass,
    })
}
/**
 * @brief: 指标概览
 * @author: Scarlett Xiao
 * @Date: 2022-01-13 16:21:27
 * @param {*} params 查询参数
 * orgId 一级机构id
 * type 时间类型（Y：年份 、M:月份）
 * year 年份（yyyy）
 * month 年月（yyyy-MM）
 * searchType 查询指标类型（0:成活率、1：饲料系数、2：每公斤卵出苗量、3：动保金额）
 * breedTypeClass 查询类型 （egg：育苗、fish：养成）
 */
export function quotaInfo(params) {
  let {
    orgId,
    type,
    year,
    month,
    breedTypeClass,
    searchType
  } = params;
  return http.post('/mdtIndicatorsOrg/getMdtIndicatorsOrgByChart', {
    orgId,
    type,
    year: type == 'M' ? '' : year,
    month: type == 'Y' ? '' : month,
    breedTypeClass,
    searchType
  });
}
/**
 * @brief: 汇总数据 四个指标参数（销售数量、收获产量、存塘成本、育苗利润【养成利润】）
 * @author: Scarlett Xiao
 * @Date: 2022-01-20 14:01:34
 * @param {*} params 查询参数
 * orgId 一级机构id
 * type 时间类型（Y：年份 、M:月份）
 * year 年份（yyyy）
 * month 年月（yyyy-MM）
 * breedTypeClass 查询类型 （egg：育苗、fish：养成）
 */
export function totalDataInfo(params) {
  let {
    orgId,
    type,
    year,
    month,
    breedTypeClass
  } = params;
  return http.post('/outFishProfitOrg/getFourIndicatorsValue', {
    orgId,
    type,
    year: type == 'M' ? '' : year,
    month: type == 'Y' ? '' : month,
    breedTypeClass,
  });
}
// 地图数据-获取分公司机构位置地址
export function mapInfo(orgId) {
  return http.get(`/org/getSubOrgList/${orgId}`);
}
// 获取当前公司的信息
export function getCurrOrgInfo(orgId) {
  return http.get(`/org/get/${orgId}`);
}